import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=e2a3ab62&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a3ab62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2a3ab62')) {
      api.createRecord('e2a3ab62', component.options)
    } else {
      api.reload('e2a3ab62', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=e2a3ab62&scoped=true&", function () {
      api.rerender('e2a3ab62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2eB1Y6V0rB0EZ/JS/comp/Accordion.vue"
export default component.exports